import {
  BLACK,
  GRAY_SCALE_01,
  GRAY_SCALE_06,
  GRAY_SCALE_08,
} from 'bd-web-components/src/utils/dash-colors'
import styled from 'styled-components'

export const Container = styled.div`
  width: 100%;
  @media (max-width: 806px) {
    overflow-x: hidden !important;
    width: 100%;
    position: relative;
  }
`

export const ContainerCard = styled.div`
  display: flex;
  max-width: 100%;
  height: 414px;
  border-radius: 15px 5px 5px 15px;
  background: #fff;
  flex-direction: column;
  overflow: auto;

  ::-webkit-scrollbar {
    width: 8px;
  }
  ::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 5px;
  }

  ::-webkit-scrollbar-thumb {
    background: #b7b7b7;
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #888;
  }

  @media (max-width: 920px) {
    height: 340px;
  }
  @media (max-width: 806px) {
    height: 213px;
  }
`
export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  background-color: #fff;
  padding: 30px 35px 42px 41px;
  @media (max-width: 806px) {
    display: none;
  }
`

export const StickyHederScroll = styled.div`
  position: sticky;
  top: 0;
`

export const TitleContainer = styled.table`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 274px;
  height: 36px;
`

export const TableHeader = styled.th`
  display: flex;
  justify-content: space-between;
  width: 100%;
  background-color: #fff;
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-weight: 600;
  padding: 0px 41px 26px 41px;
  min-width: 715px;
  @media (max-width: 806px) {
    padding: 15px;
    font-size: 12px;
  }
`

export const TableBody = styled.tbody`
  padding: 0px 41px 13px 41px;
  display: inline-block;
  min-width: 715px;
  @media (max-width: 806px) {
    padding: 0px 15px;
  }
  tr {
    display: flex;
    justify-content: space-between;
    margin-bottom: 13px;
    border-top: 1px dashed ${GRAY_SCALE_08};
    @media (max-width: 806px) {
      margin-bottom: 6px;
    }
    &:first-child {
      border-top: 1px solid #d9d9d9;
    }
    &:last-child {
      border-bottom: 1px dashed #d9d9d9;
      padding-bottom: 13px;
    }
    td {
      width: 100px;
      overflow: hidden;
      display: inline-block;
      white-space: break-spaces;
      font-family: 'Inter', sans-serif;
      font-size: 13px;
      font-weight: 500;
      margin-top: 23px;
      &:last-child {
        text-align: center;
      }
      @media (max-width: 806px) {
        font-size: 12px;
      }
    }
  }
`

export const TitleContainerMobile = styled.div`
  display: none;
  @media (max-width: 806px) {
    display: flex;
    margin-bottom: 1rem;
  }
`

export const TitleTextMobile = styled.h1`
  font-size: 16px;
  font-weight: 600;
`

export const Title = styled.h2`
  color: ${BLACK};
  font-weight: 500;
  font-size: 28px;
  font-family: 'Inter', sans-serif;
`

export const SelectBox = styled.div`
  display: flex;
  position: relative;
  width: 203px;
  &.active-grey {
    .select-1 {
      border: ${BLACK};
    }
    .select-label {
      top: -8px;
      background: ${BLACK};
      font-size: 11px;
      transition: 250ms;
    }
  }
  @media (max-width: 920px) {
    display: none;
  }
  &.focus,
  &.active {
    .select-label {
      color: ${BLACK};
      background-color: ${GRAY_SCALE_01};
      top: -8px;
      font-size: 10px;
      font-family: 'Inter', sans-serif;
      transition: 250ms;
    }
  }
  &.active {
    .select-1 {
      border: 2px solid ${GRAY_SCALE_08};
    }
  }
`

export const SelectLabel = styled.label`
  position: absolute;
  color: ${BLACK};
  font-size: 16px;
  font-weight: 400;
  max-width: calc(100% - (2 * 8px));
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  left: 8px;
  top: 13px;
  padding: 0 8px;
  transition: 250ms;
  user-select: none;
  pointer-events: none;
`

export const SelectInputField = styled.select`
  box-sizing: border-box;
  font-size: 14px;
  font-weight: 400;
  font-family: 'Inter', sans-serif;
  height: 50px;
  width: 100%;
  border-radius: 4px;
  color: ${BLACK};
  border: ${GRAY_SCALE_08};
  padding: 13px 15px;
  transition: 250ms;
  &:focus {
    outline: none;
    border: ${GRAY_SCALE_08};
    transition: 250ms;
  }
`
export const StyledTR = styled.tr`
  display: flex;
  align-items: center;
`
export const StyledTd = styled.td`
  width: 250px !important;
`

export const StyledInfo = styled.div`
  display: flex;
  align-items: center;
  justify-content: start;
`

export const NewMobileStyleTable = styled.table`
  border: 0;
  border-collapse: collapse;
  min-width: 660px;
  width: 100%;
  max-width: 850px;
  margin: 0 0px;

  thead {
    border-radius: 5px;
    height: 48px;
    text-align: left;

    tr {
      border-bottom: solid 1px ${GRAY_SCALE_08};
      margin: 0 40px;
      padding: 0 40px;
    }

    .large-th {
      min-width: 200px;
    }
  }

  th {
    color: #212d45;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 19.6px;
    vertical-align: middle;
    padding-right: 8px;
  }

  td {
    border: 0;
    color: #2f4264;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 19.6px;
    vertical-align: middle !important;
    text-align: left;
    padding-right: 5px;
  }

  tbody {
    tr {
      height: 74px;
      border-bottom: dashed 1px ${GRAY_SCALE_08};
    }

    td {
      .column-container {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        height: 100%;
        padding: 0px 10px;
        background-color: red;
      }

      .column-container.sector {
        min-width: 425px;
      }

      .column-container.totalizer {
        min-width: 425px;
      }

      .column-container.total {
        min-width: 100px;
      }

      .column-container.access {
        min-width: 90px;
      }

      .column-container.value {
        min-width: 110px;
      }

      .border {
        background-color: #d4e3e9;
        height: 15px;
        width: 2px;
      }
    }
  }

  tbody td.action-cell {
    justify-content: center !important;
    align-items: center !important;
    text-align: center !important;
    border-bottom: none !important;
  }

  tbody td.action-cell::before {
    content: none !important;
  }

  /* -------------------- MOBILE MAGIC -------------------- */
  @media (max-width: 768px) {
    border: 0;
    min-width: unset;
    width: 100%;
    overflow-x: hidden !important;
    position: relative;

    thead {
      /* Esconde o cabeÃ§alho mas mantÃ©m acessibilidade */
      border: none;
      clip: rect(0 0 0 0);
      height: 1px;
      margin: -1px;
      overflow: hidden;
      padding: 0;
      position: absolute;
      width: 1px;
    }

    tbody tr {
      display: block;
      border: 1px solid ${GRAY_SCALE_06};
      border-radius: 8px;
      margin-bottom: 1rem;
      padding: 0.75rem;
      height: 100%;
    }

    tbody td {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      text-align: left;
      border-bottom: 1px solid #eee;
      font-size: 0.9rem;
      padding: 0.5rem 0;

      /* Aqui o rÃ³tulo de cada cÃ©lula */
      &::before {
        content: attr(data-label);
        font-weight: 600;
        text-transform: uppercase;
        color: #212d45;
        flex: 0 0 45%;
      }

      /* remove a borda da Ãºltima linha */
      &:last-child {
        border-bottom: none;
      }
    }

    /* limpa medidas fixas das colunas */
    .column-container,
    .column-container.sector,
    .column-container.total,
    .column-container.access,
    .column-container.value,
    .column-container.totalizer {
      min-width: unset !important;
      max-width: unset !important;
      width: 100% !important;
      flex-direction: row;
    }

    .hidder {
      display: none;
    }

    .text-left {
      text-align: left;
      padding-left: 0;
    }
  }

  .text-left {
    text-align: left;
    padding-left: 30px;
  }
`